export default function DirectorySearch({ id, value, onChange, placeholder, resultCount }) {
  return (
    <div>
      <label htmlFor={id} className="text-sm font-black text-neutral-950">Search this directory</label>
      <input
        id={id}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className="focus-ring mt-3 w-full rounded-2xl border border-neutral-300 bg-white px-4 py-3 text-base text-neutral-950 placeholder:text-neutral-400"
      />
      <p className="mt-3 text-sm font-semibold text-neutral-600" role="status" aria-live="polite">
        {resultCount} verified result{resultCount === 1 ? "" : "s"}
      </p>
    </div>
  );
}
